import type { PlatformAdapter, PayResult } from './types';

/** Браузер без Telegram: dev-вход, имитация оплаты, Web Share API. Основа для CapacitorAdapter. */
export class WebAdapter implements PlatformAdapter {
  readonly name = 'web' as const;
  getAuthPayload() {
    return { provider: 'dev' as const, devId: Number(localStorage.getItem('devId') ?? 1), tzOffset: -new Date().getTimezoneOffset() };
  }
  getStartParam() { return new URLSearchParams(location.search).get('startapp'); }
  haptic() { try { navigator.vibrate?.(10); } catch { /* нет vibrate */ } }
  async pay(invoiceUrl: string): Promise<PayResult> {
    if (invoiceUrl.startsWith('dev://pay/')) return { dev: true, productId: invoiceUrl.slice(10) };
    window.open(invoiceUrl, '_blank');
    return 'pending';
  }
  share(text: string, url?: string) {
    if (navigator.share) void navigator.share({ text, url }).catch(() => undefined);
    else void navigator.clipboard?.writeText(`${text} ${url ?? ''}`);
  }
  openLink(url: string) { window.open(url, '_blank'); }
  setBackHandler() { /* в браузере — история роутера */ }
  getLocale() { return navigator.language; }
  close() { /* noop */ }
}
